import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { OnboardingPage } from './pages/OnboardingPage';
import { DashboardPage } from './pages/DashboardPage';
import { ContentIdeasPage } from './pages/ContentIdeasPage';
import { PostComposerPage } from './pages/PostComposerPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { LocalIntelligencePage } from './pages/LocalIntelligencePage';
import { CollaborationPage } from './pages/CollaborationPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { SettingsPage } from './pages/SettingsPage';
import { MainLayout } from './components/MainLayout';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/onboarding" element={<OnboardingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/" element={<MainLayout data-id="element-7" />} data-id="element-6">
          <Route index element={<Navigate to="/dashboard" replace data-id="element-9" />} data-id="element-8" />
          <Route path="dashboard" element={<DashboardPage data-id="element-11" />} data-id="element-10" />
          <Route path="content-ideas" element={<ContentIdeasPage data-id="element-13" />} data-id="element-12" />
          <Route path="post-composer" element={<PostComposerPage data-id="element-15" />} data-id="element-14" />
          <Route path="campaigns" element={<CampaignsPage data-id="element-17" />} data-id="element-16" />
          <Route path="local-intelligence" element={<LocalIntelligencePage data-id="element-19" />} data-id="element-18" />
          <Route path="collaboration" element={<CollaborationPage data-id="element-21" />} data-id="element-20" />
          <Route path="analytics" element={<AnalyticsPage data-id="element-23" />} data-id="element-22" />
          <Route path="settings" element={<SettingsPage data-id="element-25" />} data-id="element-24" />
        </Route>
      </Routes>
    </BrowserRouter>;
}